export function isJSON (jsonStr) {
  let parsed = null
  try {
    parsed = JSON.parse(jsonStr)
  } catch (e) {
    return false
  }
  return typeof parsed === 'object' && parsed !== null
}

export function getParsedJSON (jsonStr) {
  while (isJSON(jsonStr)) {
    jsonStr = JSON.parse(jsonStr)
  }
  return jsonStr
}



// WEBPACK FOOTER //
// ./src/utilities/json.helper.js